import { commonLocale } from "./common";
const locale = {
  ...commonLocale,
  fieldDateFormat: 'DD-MM-YYYY',
  fieldDateTimeFormat: 'DD-MM-YYYY HH:mm:ss',
  fieldMonthFormat: 'MM-YYYY',
  locale: 'mr_IN',
  today: 'आज',
  now: 'आता',
  backToToday: 'आजवर परत जा',
  ok: 'ठीक आहे',
  clear: 'साफ करा',
  week: 'आठवडा',
  month: 'महिना',
  year: 'वर्ष',
  timeSelect: 'वेळ निवडा',
  dateSelect: 'दिनांक निवडा',
  weekSelect: 'आठवडा निवडा',
  monthSelect: 'महिना निवडा',
  yearSelect: 'वर्ष निवडा',
  decadeSelect: 'दशक निवडा',
  previousMonth: 'मागील महिना',
  nextMonth: 'पुढचा महिना',
  previousYear: 'गेल्या वर्षी',
  nextYear: 'पुढचे वर्ष',
  previousDecade: 'मागील दशक',
  nextDecade: 'पुढचे दशक',
  previousCentury: 'मागील शतक',
  nextCentury: 'पुढचे शतक',
  shortWeekDays: ['रवि', 'सोम', 'मंगळ', 'बुध', 'गुरु', 'शुक्र', 'शनि'],
  shortMonths: ['जाने', 'फेब्रु', 'मार्च', 'एप्रिल', 'मे', 'जून', 'जुलै', 'ऑगस्ट', 'सप्टें', 'ऑक्टो', 'नोव्हें', 'डिसें']
};
export default locale;